import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[numericValue]'
})
export class NumericValueDirective {
  regExp = new RegExp(/^[0-9]+$/);
  private specialKeys = [
    'Backspace',
    'Tab',
    'End',
    'Home',
    'ArrowLeft',
    'ArrowRight',
    'Del',
    'Delete'
  ];

  constructor(private element: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }
    const currentValue = this.element.nativeElement.value;
    const nextValue = [currentValue, event.key].join('');
    if (nextValue && !String(event.key).match(this.regExp)) {
      event.preventDefault();
    }
  }
}
